export default () => ({
  roles: []
});
